import Databases from 'components/view/databases/Index'
import {tabNames, TabType} from 'router/settings'
import {GridStateParamsType} from 'commonTypes'
import defaultDatabasesState from 'redux/databases/state'
import {StateDeclaration} from '@uirouter/core'

const databasesState = {
  name: 'databases',
  url: '/databases',
  component: Databases,
  resolve: [{
    token: 'title',
    resolveFn: () => tabNames[TabType.databases],
  }],
  params: {
    filters: defaultDatabasesState.gridSession.filters,
  } as GridStateParamsType,
} as StateDeclaration

export default databasesState
